// @flow
/* eslint-disable no-shadow */
import React from 'react';
import Toggle from 'react-toggled';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import { withTranslation } from 'react-i18next';
import SubtitlesOutlinedIcon from '@material-ui/icons/SubtitlesOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import FullscreenOutlinedIcon from '@material-ui/icons/FullscreenOutlined';
import ScribeFontSizeInputContainer from '../../modules/scribe/ScribeFontSizeInputContainer';
import ScribeSetThemeColorContainer from '../../modules/scribe/ScribeSetThemeColorContainer';
import ScribeSetCurseFilterContainer from '../../modules/scribe/ScribeSetCurseFilterContainer';
import ZoomBroadcastCaptionMenuItem from '../../modules/scribe/ZoomBroadcastCaptionMenuItem';
import { styles } from '../../modules/scribe/SidebarHelpers';
import { toggleSideBar, updateFullScreen } from '../../actions';

function CaptionsSettings({
  classes,
  isInConversation,
  t,
  toggleSideBar,
  user,
  updateFullScreen,
  fullScreen,
}: {
  classes: Object,
  fullScreen: boolean,
  isInConversation: boolean,
  t: Object,
  toggleSideBar: Function,
  updateFullScreen: Function,
  user: Object,
}) {
  const handleUpdateFullScreen = e => {
    e.preventDefault();
    // $FlowFixMe
    if (window.navigator.share && document.body.fullScreen) {
      // $FlowFixMe
      document.body.requestFullscreen();
    }

    updateFullScreen(!fullScreen);
    toggleSideBar();
  };

  return (
    <Toggle key="0_toggle_array" defaultOn>
      {({ on, getTogglerProps }) => [
        <ListItem
          button
          {...getTogglerProps()}
          key="toggle_head"
          classes={{
            focused: classes.root,
          }}
        >
          <ListItemIcon>
            <SubtitlesOutlinedIcon />
          </ListItemIcon>
          <ListItemText classes={{ root: classes.listItemText }} primary={t('sidebar.captionSettings')} />
          <ListItemIcon classes={{ root: classes.expandIcon }}>
            {on ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
          </ListItemIcon>
        </ListItem>,
        <Collapse in={on} key="toggle_collapse">
          {isInConversation && <ScribeFontSizeInputContainer />}
          {isInConversation && <ScribeSetCurseFilterContainer />}
          <ScribeSetThemeColorContainer />
          <ListItem
            onClick={handleUpdateFullScreen}
            style={{
              paddingLeft: 32,
            }}
            role="button"
            button
          >
            <ListItemIcon>
              <FullscreenOutlinedIcon />
            </ListItemIcon>
            <ListItemText classes={{ root: classes.listItemText }} primary={t('theme.fullScreen')} />
          </ListItem>
          {isInConversation && user && user.features && user.features['zoom-caption'] && (
            <ZoomBroadcastCaptionMenuItem />
          )}
        </Collapse>,
      ]}
    </Toggle>
  );
}

const mapStateToProps = ({
  scribeConversation: { isInConversation },
  scribeTranscriptUI: { fullScreen },
  scribeSession: { captioner },
}) => ({
  isInConversation,
  fullScreen,
  user: captioner,
});

export default connect(mapStateToProps, {
  toggleSideBar,
  updateFullScreen,
})(withTranslation()(withStyles(styles, { withTheme: true })(withRouter(CaptionsSettings))));
